import CustomCheckbox from "@/shared/components/ui/Checkbox/CustomCheckbox";
import StatusDot from "./StatusDot";

const StatusOptionRow = ({
  label,
  dotColor,
  checked = false,
  onSelect,
  disabled = false,
}) => {
  const handleSelect = () => {
    if (disabled || checked) return;
    onSelect?.();
  };

  return (
    <div
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (!disabled && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          handleSelect();
        }
      }}
      className={`w-full flex items-center px-4 transition-colors ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
      }`}
    >
      <div className="pointer-events-none">
        <CustomCheckbox checked={checked} onChange={() => {}} disabled={disabled} />
      </div>
      <span className="flex-1 text-left p-1.5 text-[0.75rem] font-normal text-gray-800 dark:text-gray-100 font-inter">
        {label}
      </span>
      <StatusDot color={dotColor} />
    </div>
  );
};

export default StatusOptionRow;
